import type { PermissionCatalog } from '@ztechapps/common.contract'
import { appShellPermissions } from '@ztechapps/common.contract'
import { customerPermissions } from '@ztechapps/customer.common'
import { invoicePermissions } from './invoicePermissions'
import { paymePermissions } from './paymePermissions'

// Array order is display order in the Set Permissions modal; a product hides a
// permission by omitting it here, never by a flag or a commented-out entry.
// Customer composes canView/canEdit only — canDelete exists on the shared pool
// (hauler composes it) but PayMe has never offered it.
export const paymePermissionCatalog: PermissionCatalog = [
  {
    label: 'Super Admin',
    permissions: [appShellPermissions.superAdmin],
  },
  {
    label: 'App Admin',
    permissions: [appShellPermissions.admin.canAccess],
  },
  {
    label: 'Overview',
    permissions: [appShellPermissions.overview.canView],
  },
  {
    label: 'App',
    permissions: [paymePermissions.app.canAccess],
  },
  {
    label: 'Customer',
    permissions: [customerPermissions.canView, customerPermissions.canEdit],
  },
  {
    label: 'Invoice',
    permissions: [invoicePermissions.canView, invoicePermissions.canEdit],
  },
  {
    label: 'Reports',
    permissions: [appShellPermissions.reports.canView],
  },
  {
    label: 'Settings',
    permissions: [appShellPermissions.setting.canView, appShellPermissions.setting.canEdit],
  },
]
